<template>
  <div>
    <v-container>
      <v-row>
        <v-col>
          <v-text-field
            label="Third ID ECommerce"
            @input="updateThirdIdFiltered()"
            prepend-icon="mdi-magnify"
            v-model="sub_id"
            :prefix="`50- ${this.sub_id == null ? '' : this.sub_id} - `"
            solo
            clearable
          ></v-text-field>
        </v-col>
        <v-col>
          <v-text-field
            label="Country code"
            @input="updateThirdIdFiltered()"
            v-model="countryFilter"
            solo
            clearable
          ></v-text-field>
        </v-col>
        <v-col>
          <v-switch
            v-model="show_deleted"
            label="Show deleted"
            @change="syncEcommerceFiltered()"
          ></v-switch>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <h4 class="text-danger">The Posdata repository is for internal use by the Posdata team only
            and is not Decathlon's official repository; it is a replication of the masterdata repository.</h4>
        </v-col>
      </v-row>
    </v-container>
    <v-container fluid>
      <v-simple-table class="elevation-10">
        <template v-slot:default>
          <thead>
          <tr>
            <th scope="col">ID</th>
            <th scope="col">Third ID ECommerce</th>
            <th scope="col">Name</th>
            <th scope="col">Type Code</th>
            <th scope="col">Begin</th>
            <th scope="col">End</th>
            <th scope="col">ThirdIDCountry - Country Code</th>
          </tr>
          </thead>
          <tbody>
          <tr
            v-for="ecommerce in ecommercesFiltered"
            :key="ecommerce.thirdIdEcommerce"
          >
            <td>{{ ecommerce.id }}</td>
            <td>{{ ecommerce.thirdIdEcommerce }}</td>
            <td>{{ ecommerce.name }}</td>
            <td>{{ ecommerce.typeCode }}</td>
            <td>{{ ecommerce.begin }}</td>
            <td>{{ ecommerce.end }}</td>
            <td v-if="!isCountryNull(ecommerce)">
              {{ ecommerce.country.thirdIdCountry }} -
              {{ ecommerce.country.code }}
            </td>
            <td v-if="isCountryNull(ecommerce)">No country found</td>
            <td>
              <router-link
                v-if="isAdminUser"
                class="btn btn-edit"
                v-bind:to="{
                    path: 'editECommerce',
                    query: { id: ecommerce.id },
                  }"
              >
                <v-icon>mdi-pencil</v-icon>
                <span class="editspan">Edit</span>
              </router-link>
            </td>
          </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-container>
  </div>
</template>

<script>
/* eslint-disable */
import {parameters} from "../../parameters";
import {httpClient, authState} from "../../requesters/httpClient";
import {USER_ROLE} from "../../requesters/userConstants";

export default {
  name: "ECommerces",
  data() {
    return {
      ecommerces: [],
      ecommercesFiltered: [],
      id: "50",
      sub_id: null,
      third_id_filtered: "50--",
      show_deleted: false,
      countryFilter: null,
    };
  },
  computed: {
    isAdminUser() {
      return authState.role === "ROLE_ADMIN";
    }
  },
  async mounted() {
    await httpClient
      .get(`${parameters.posdataRefUrl}/e-commerces`)
      .then((response) => {
        this.ecommerces = response.data;
        this.syncEcommerceFiltered();
      })
      .catch((error) => {
        throw error;
      });
  },
  methods: {
    updateThirdIdFiltered: function () {
      this.sub_id = this.sub_id == null ? "" : this.sub_id;
      this.third_id_filtered = this.id + "-" + this.sub_id + "-" + this.sub_id;
      this.syncEcommerceFiltered();
    },

    syncEcommerceFiltered: function () {
      this.ecommercesFiltered = new Array();
      this.ecommerces.forEach((ecommerce) => {
        if (
          this.isECommerceFiltered(ecommerce) &&
          (this.show_deleted || (!this.show_deleted && ecommerce.end == null))
        ) {
          this.ecommercesFiltered.push(ecommerce);
        }
      });
    },

    isECommerceFiltered: function (ecommerce) {
      return (
        (this.third_id_filtered === "50--" ||
          this.third_id_filtered === ecommerce.thirdIdEcommerce) &&
        (this.countryFilter === null ||
          this.countryFilter === "" ||
          (!this.isCountryNull(ecommerce) &&
            ecommerce.country.code === this.countryFilter))
      );
    },
    isCountryNull: function (ecommerce) {
      return ecommerce.country === null;
    }
  },
};
</script>





// WEBPACK FOOTER //
// src/components/eCommerces/ECommerces.vue